import TurndownService from "turndown";

const turndownService = new TurndownService({
  headingStyle: "atx",
  codeBlockStyle: "fenced",
});

// Images : toujours émettre du HTML inline pour éviter la corruption des URLs
// signées AWS S3 par Turndown (qui encode les & en &amp; dans les URLs Markdown).
turndownService.addRule("image", {
  filter: "img",
  replacement: (_content: string, node: any) => {
    const alt = node.getAttribute?.("alt") || node.alt || "";
    // Use getAttribute to preserve s3key:// scheme exactly as-is;
    // node.src would be browser-resolved and may mangle custom schemes.
    const src = node.getAttribute?.("src") || node.src || "";
    const style: string = node.getAttribute?.("style") ?? "";
    const widthMatch = style.match(/width:\s*(\d+)px/);

    const altAttr = alt ? ` alt="${alt}"` : "";
    if (widthMatch) {
      const w = widthMatch[1];
      return `\n<img src="${src}"${altAttr} style="width: ${w}px; max-width: 100%; height: auto;" />\n`;
    }

    return `\n<img src="${src}"${altAttr} style="max-width: 100%; height: auto;" />\n`;
  },
});

/**
 * Convert HTML content from TipTap to Markdown
 */
export function htmlToMarkdown(html: string): string {
  if (!html) return "";
  return turndownService.turndown(html);
}

